module.exports = __webpack_public_path__ + "media/images/emblems/Kehrsatz-coat_of_arms-c1fe7c431d03a07253729dc88aa05b8a.svg";